<div class="file-preview-page document-intake-file-upload">
    @if (!fileError && previewSupported) {
        <file-viewer [file]="file"></file-viewer>
    }
    @if (fileError) {
        <div class="download-preview-error">
            Cannot show file due to processing error
        </div>
    }
    @if (!(fileError || !attachmentID || previewSupported)) {
        <div>
            <span class="anchor-style" (click)="downloadAttachment()">Click to download or view in native application.</span>
        </div>
    }
</div>
